// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MobileNavBar_wrapper__A9czg","dark":"dark","logo":"MobileNavBar_logo__azQgp","menu":"MobileNavBar_menu__Md937","switcher":"MobileNavBar_switcher__YyAWO"};